import { useCallback, useEffect, useState } from 'react'
import {
  Text,
  View,
  ScrollView,
  StyleSheet,
  TouchableOpacity,
  SafeAreaView,
  Platform,
  RefreshControl
} from 'react-native'

import { Ionicons } from '@expo/vector-icons'
import * as WebBrowser from 'expo-web-browser'

// styles
import { colorPalette, fontPalette, globalStyles } from '../../static/styles/global'

// i18n
import { en as welcomeEn } from '../../i18n/WelcomeScreen'

// screens & components
import Card from '../../components/shared/card/Card'
import CardListItem from '../../components/shared/card/CardListItem'
import CardInfoStatus from '../../components/shared/card/CardInfoStatus'
import ScreenStatus from '../../components/home/ScreenStatus'
import { Loading } from '../../components/shared/navigator/Loading'

// stores
import { useHomeStore } from '../../stores/home'
import HomeSkeleton from '../../skeletons/HomeSkeleton'
import { Badge } from '../../components/shared/button/Badge'
import MyScrollView from '../../components/shared/navigator/MyScrollView'
import { useLabourStore } from '../../stores/labour'
import { useInitializeStore } from '../../stores/initialize'
import LanguageSelectionScreen from './LanguageScreen'
//translaion
import { useTranslation } from 'react-i18next'

import AsyncStorage from '@react-native-async-storage/async-storage'
import { useFocusEffect } from '@react-navigation/native'
import React from 'react'
import { useCommunicateStore } from '../../stores/communicate'
import { usePersonalStore } from '../../stores/personalInfo'
import Constants from 'expo-constants'
import moment from 'moment'
import { useFormsStore } from '../../stores/onboarding'

const HomeScreen = ({ navigation, route }): JSX.Element => {
  const [refreshing, setRefreshing] = useState(false)

  // params
  const { params } = route
  const { mostRecentUserOnBoardings: userId, refresh } = params

  // stores' data
  const homeStore = useHomeStore()
  const labourStore = useLabourStore()
  const intializeStore = useInitializeStore()
  const personalstore = usePersonalStore()
  const onboardingStore = useFormsStore()
  const {
    messages: messages,
    fetchAllMessages,
    messagesCount,
    unreadMessage
  } = useCommunicateStore()
  const { t } = useTranslation()
  const handleHitAPI = async () => {
    if (!homeStore?.homeData?.isMaintanance) {
      try {
        const id = intializeStore.initializeData.userkey
        const response = await labourStore.fetchData(id)
        if (response !== null) {
          navigation.navigate('LabourScreen')
        }
      } catch (error) { }
    }
  }

  // pull down to refresh the screen
  const onRefresh = useCallback(() => {
    setRefreshing(true)
    setTimeout(() => {
      navigation.replace('Onboarding', { refresh: Math.random() })
      setRefreshing(false)
    }, 1000)
  }, [])

  const [loading, setLoading] = useState(true)
  useEffect(() => {
    if (homeStore?.homeData?.isMaintanance) {
      navigation.navigate('Maintenance')
    }
    setLoading(false)
  }, [homeStore?.homeData?.isMaintanance])
  useEffect(() => {
    AsyncStorage.setItem(
      'essUserKey',
      intializeStore.initializeData.userkey.toString()
    )
  }, [])

  useEffect(() => { }, [refresh])
  useEffect(() => {
    const unsubscribe = navigation.addListener('focus', () => {
      homeStore.fetchData(userId)
    })
    return unsubscribe
  }, [navigation])
  useEffect(() => {
    if (homeStore?.homeData?.isOnboarded === true) {
      handleHitAPI()
    }
  }, [homeStore?.homeData?.isOnboarded])
  useEffect(() => {
    const unsubscribe = navigation.addListener('focus', () => {
      if (homeStore?.homeData?.isOnboarded === true) {
        handleHitAPI()
      }
    })
    return unsubscribe
  }, [homeStore?.homeData?.isOnboarded])
  const [initialLoading, setInitialLoading] = useState(true)

  // useEffect(() => {
  //   const fetchData = async () => {
  //     await homeStore.fetchData(userId)

  //     if (initialLoading) {
  //       setInitialLoading(false)
  //     }
  //   }

  //   fetchData()
  //   const intervalId = setInterval(fetchData, 60000)
  //   return () => clearInterval(intervalId)
  // }, [initialLoading])

  useFocusEffect(
    React.useCallback(() => {
      const fetchData = async () => {
        await homeStore.fetchData(userId)
        await onboardingStore.fetchData(userId)
        if (initialLoading) {
          setInitialLoading(false)
        }
      }

      fetchData()
      const intervalId = setInterval(fetchData, 60000)
      return () => clearInterval(intervalId)
    }, [initialLoading])
  )
  useFocusEffect(
    React.useCallback(() => {
      const fetchData = async () => {
        await messagesCount(userId)
      }

      fetchData()
      const intervalId = setInterval(fetchData, 60000)
      return () => clearInterval(intervalId)
    }, [])
  )

  useEffect(() => {
    labourStore.getDaysOrder(intializeStore?.initializeData?.userkey)
  }, [])

  useEffect(() => {
    const daysOrder = [
      'sunday',
      'monday',
      'tuesday',
      'wednesday',
      'thursday',
      'friday',
      'saturday'
    ]
    // const daysOrder = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
    const startIndex = daysOrder.indexOf(
      labourStore?.startdayofweekdata?.payPeriodDay
    ) // Convert to index (Sunday = 0, Monday = 1, etc.)
    //  const startIndex =  daysOrder.indexOf('friday')
    if (startIndex !== -1) {
      moment.updateLocale('en', {
        week: {
          dow: startIndex // Set the start of the week dynamically
        }
      })
    } else {
      moment.updateLocale('en', {
        week: {
          dow: 1 // Set the start of the week dynamically
        }
      })
    }
    labourStore.setStartWeekDate(moment().startOf('week').format('MM/DD/YYYY'))
    labourStore.setEndWeekDate(moment().endOf('week').format('MM/DD/YYYY'))
  }, [labourStore?.startdayofweekdata?.payPeriodDay])

  useEffect(() => {
    const data = {
      entityId: personalstore?.personalData?.entityId,
      essUserKey: intializeStore?.initializeData?.userkey,
      interface: 'web',
      version: null,
      workhappyVersion: Constants.expoConfig.version
    }
    const postDetails = async () => {
      const flag = JSON.parse(await AsyncStorage.getItem('login'))
      if (flag == true && personalstore?.personalData?.entityId) {
        const response = await homeStore.postlogDetails(data)
        await AsyncStorage.setItem('login', JSON.stringify(false))
      }
    }
    postDetails()
  }, [personalstore?.personalData?.entityId])

  useEffect(() => {
    if (
      personalstore?.personalData?.entityId &&
      personalstore?.personalData?.corpEntityId
    ) {
      homeStore.fetchcorporation(
        personalstore?.personalData?.entityId,
        personalstore?.personalData?.corpEntityId
      )
    }
  }, [
    personalstore?.personalData?.entityId,
    personalstore?.personalData?.corpEntityId
  ])

  if (initialLoading || homeStore?.homeData?.isOnboarded == true)
    return <HomeSkeleton />

  // if (homeStore.loading || homeStore?.homeData?.isOnboarded == true)
  //   return <HomeSkeleton />

  if (homeStore.error) return <ScreenStatus message={homeStore.error} />

  if (loading) {
    return <HomeSkeleton />
  }

  return (
    homeStore.homeData && (
      <MyScrollView
        refreshControl={
          <RefreshControl refreshing={refreshing} onRefresh={onRefresh} />
        }
      >
        <View style={[globalStyles.primaryBgColor, globalStyles.containerBand]}>
          <View
            style={[
              globalStyles.vCenterItems,
              globalStyles.pl8,
              globalStyles.pr8
            ]}
          >
            <Text
              style={[
                globalStyles.text,
                globalStyles.fwBold,
                globalStyles.fs30,
                globalStyles.whiteTextColor,
                globalStyles.textCenter
              ]}
            >
              {t('welcome')}
            </Text>
            {homeStore.homeData.storeName && (
              <Text
                style={[
                  globalStyles.text,
                  globalStyles.fwBold,
                  globalStyles.fs30,
                  globalStyles.whiteTextColor,
                  globalStyles.textCenter,
                  globalStyles.mb3
                ]}
              >
                {homeStore.homeData.storeName}
              </Text>
            )}
            <View style={[globalStyles.mediumContainer]}>
              <Text
                style={[
                  globalStyles.text,
                  globalStyles.whiteTextColor,
                  globalStyles.textCenter,
                  globalStyles.fs20
                ]}
              >
                {t('status')}
              </Text>
            </View>
          </View>
        </View>
        <View style={[globalStyles.containerOverlap]}>
          <Card
            action={() => {
              navigation.push('StoreInformation', {})
            }}
          >
            {homeStore?.homeData?.storeStatusValue === 'P' ? (
              <CardInfoStatus
                title={t('storeinformation')}
                status={homeStore?.homeData?.storeStatusDescription}
                flat
                message={homeStore?.homeData?.lastStoreMessage}
                isAlertMessage
                extraParams={{
                  sentMessageDate: homeStore?.homeData?.lastStoreMessageDate,
                  replyMessageDate: homeStore?.homeData?.lastStoreResponseDate
                }}
                initiatorType={homeStore?.homeData?.lastStoreInitiatorType}
              />
            ) : homeStore?.homeData?.storeStatusValue === 'V' ? (
              <CardInfoStatus
                title={t('storeinformation')}
                status={homeStore?.homeData?.storeStatusDescription}
                flat
                message={homeStore?.homeData?.lastStoreMessage}
                reply={homeStore?.homeData?.lastStoreResponse}
                isAlertMessage
                extraParams={{
                  sentMessageDate: homeStore?.homeData?.lastStoreMessageDate,
                  replyMessageDate: homeStore?.homeData?.lastStoreResponseDate
                }}
                initiatorType={homeStore?.homeData?.lastStoreInitiatorType}
              />
            ) : (
              <CardInfoStatus
                title={t('storeinformation')}
                status={homeStore?.homeData?.storeStatusDescription}
                flat
              />
            )}
          </Card>
          {/* store information card */}

          <Card
            action={() => {
              navigation.navigate('PersonalBasicInformation', {})
            }}
          >
            {homeStore?.homeData?.personalStatusValue === 'P' ? (
              <CardInfoStatus
                title={t('personalInfoTitle')}
                status={homeStore?.homeData?.personalStatusDescription}
                flat
              // message={homeStore?.homeData?.lastPersonalMessage}
              // isAlertMessage
              // extraParams={{
              //   sentMessageDate: homeStore?.homeData?.lastPersonalMessageDate,
              //   replyMessageDate:
              //     homeStore?.homeData?.lastPersonalResponseDate
              // }}
              />
            ) : homeStore?.homeData?.personalStatusValue === 'R' ? (
              <CardInfoStatus
                title={t('personalInfoTitle')}
                status={homeStore?.homeData?.personalStatusDescription}
                flat
              // message={homeStore?.homeData?.lastPersonalMessage}
              // reply={homeStore?.homeData?.lastPersonalResponse}
              // isAlertMessage
              // extraParams={{
              //   sentMessageDate: homeStore?.homeData?.lastPersonalMessageDate,
              //   replyMessageDate:
              //     homeStore?.homeData?.lastPersonalResponseDate
              // }}
              />
            ) : homeStore?.homeData?.personalStatusValue === 'C' ? (
              <CardInfoStatus
                title={t('personalInfoTitle')}
                status={homeStore?.homeData?.personalStatusDescription}
                flat
              />
            ) : (
              <CardInfoStatus
                title={t('personalInfoTitle')}
                status={'NOT STARTED'}
                flat
              />
            )}
          </Card>
          {/* personal information card */}

          {homeStore?.homeData?.personalStatusValue != '' &&
            homeStore?.homeData?.personalStatusValue != 'N' &&
            onboardingStore.formList?.length > 0 && (
              <Card
                action={() => {
                  navigation.navigate('OnboardingForms', {})
                }}
              >
                <CardInfoStatus
                  title={t('onBoardingTitle')}
                  status={homeStore?.homeData?.formsStatusDescription}
                  flat
                />
              </Card>
            )}
          {homeStore?.homeData?.hasDefaultAvailability && (
            <Card
              action={() => {
                navigation.navigate(
                  homeStore?.homeData?.scheduleStatusValue === 'C'
                    ? 'ScheduleAvailabilityReadOnly'
                    : 'ScheduleAvailability',
                  {}
                )
              }}
            >
              <CardInfoStatus
                title={t('scheduleTitle')}
                status={homeStore?.homeData?.scheduleStatusDescription}
                flat
              />
            </Card>
          )}
          <Card
            action={() => {
              navigation.navigate('CommunicateWithAdmin')
            }}
          >
            <CardInfoStatus
              title={t('communicateTitle')}
              badge={
                homeStore?.homeData?.isNewMessage
                  ? {
                    text: `New Message (${unreadMessage?.data?.count})`,
                    textColor: colorPalette.white,
                    bgColor: colorPalette.tertiary
                  }
                  : null
              }
            />
          </Card>
        </View>
        {homeStore?.homeData?.storeStatusValue === 'C' &&
          homeStore?.homeData?.scheduleStatusValue === 'C' &&
          homeStore?.homeData?.personalStatusValue != 'N' &&
          homeStore?.homeData?.formsStatusValue != 'N' && (
            <View
              style={[
                globalStyles.vEndItems,
                globalStyles.vCenterItems,
                globalStyles.horizontalPadGap,
                globalStyles.horizontalMarGap
              ]}
            >
              <Text
                style={[
                  globalStyles.textCenter,
                  {  fontSize: 16, lineHeight: 21, fontFamily: fontPalette.primaryBold }
                ]}
              >
                {t('Waiting Message')}
              </Text>
            </View>
          )}
      </MyScrollView>
    )
  )
}

export default HomeScreen
